import baseService from './baseService';

export function getCountries() {
    return baseService.get('/countries');
}